import React from 'react';
import Alert from 'react-bootstrap/Alert'
import { setQuestionAnswer } from '../../api/health-questions/actions'
import { SvgArrowIcon, SvgCheckIcon, SvgTrashIcon } from '../svg';
import { showStopper } from '../../api/gui/actions'
import { 
    Tooltip, contractPaymentTypeMatch, noSpecificDispCond, checkDisplayCondition, 
    renderAdditionalQuestions, areHealthQuestionsConfirmed, isGesamtRenteHigherThanLimit, 
    isMainQuestiongroupConfirmed, isAnySinglePaymentCheckboxChecked, getEmployerStartDate, 
    calculateTotalMonthlyPayment, formatMoney,Spinner } from '../../utils'
import SsnLookup from '../ssn-lookup'
import { MultiAnsModal } from '../modals'
import { clearVidtEmployers, createEmployer } from '../../api/employers/actions';
import moment from 'moment'
import DOMPurify from 'dompurify';


class HealthQuestions extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            disabledQuestions: [],
            fund_table: {
                title: "Samtryggingarsjóður",
                tableName: "FundTable",
                tableLine: "FundLine",
                tableId: "FundId",
                tableProp: "fundTable",
                tableFilter: (fund) => {
                    return fund.IsMutualInsurance === "1"
                }
            },
            portfolioAnswers: {
                komfortdynamik: {},
                perspektive: {},
            },
            checkedQ: {}, // List of questionnaires to be created
            additionalQuestionsSet: false,
            otherDeathBenefitsSum: 0,
        }

        this.onCheckboxChange = this.onCheckboxChange.bind(this)

        this.selectAnswer = this.selectAnswer.bind(this)
        this.addMultiAnswer = this.addMultiAnswer.bind(this)
        this.sortAdditionalQuestions = this.sortAdditionalQuestions.bind(this);
        this.reEvaluateShowStopper = this.reEvaluateShowStopper.bind(this);

        this.lastShowStopperEvaluation = null;
    }

    getInitialValues(customerId) {
        return this.props.infoCollection.data.find(f => f.customerId === customerId)
    }

    componentDidUpdate(prevProps) {
        $('[data-toggle="tooltip"]').tooltip({ html: true })
        this.updateOtherDeathBenefitsSum()

        if (
            prevProps.infoCollection !== this.props.infoCollection
            || prevProps.healthQuestions.data !== this.props.healthQuestions.data
            || prevProps.healthQuestions.results !== this.props.healthQuestions.results
            || prevProps.offerType !== this.props.offerType
            || prevProps.customerId !== this.props.customerId
        ) {
            this.reEvaluateShowStopper()
        }
    }

    componentWillUnmount() {
        if (Object.keys(this.props.offers.offers[this.props.customerId]).includes('VIDT')) {
            try {
                let selectedFund = this.props.healthQuestions.data[this.props.customerId]['VIDT']['f5b4728b-856e-4357-b201-2c57b6a4882b-0']
                //let selectedFund = this.props.healthQuestions.data[this.props.customerId]['VIDT']['99a8bd0b-1bc8-46ee-9f1e-1f5acc90177c-0'] // Edda
                let fund = this.props.fundTable.data.FundTable.FundLine.filter(f => f.FundId === selectedFund)
                if (fund.length > 0) {
                    let fundOrgId = fund[0].IdNumber
                    let fundName = fund[0].Name
                    let startDate = getEmployerStartDate()
                    if (this.props.healthQuestions.groups[this.props.customerId] &&
                        this.props.healthQuestions.groups[this.props.customerId].VIDT &&
                        this.props.healthQuestions.groups[this.props.customerId].VIDT.VIDT &&
                        this.props.healthQuestions.groups[this.props.customerId].VIDT.VIDT.termination &&
                        this.props.healthQuestions.groups[this.props.customerId].VIDT.VIDT.termination.VIDTformerFund !== "000") {
                        startDate = moment.utc(startDate).add(2, 'months').startOf('month');
                    }

                    Promise.resolve(this.props.dispatch(clearVidtEmployers(this.props.customerId)))
                        .then(() => {
                            this.props.dispatch(createEmployer(this.props.customerId, { OrgId: fundOrgId, Name: fundName, contractType: "VIDT" }, moment.utc(startDate).format("DD.MM.YYYY")))
                        })
                }
            } catch (e) { }
        }

        // Makes a list of questionnaires to be answered by customer
        if (Object.keys(this.state.checkedQ).length > 0) {
            if (!this.props.healthQuestions.additionalQuestions) {
                this.props.healthQuestions.additionalQuestions = {};
            }
            for (let key of Object.keys(this.state.checkedQ)) {
                if (this.state.checkedQ[key]) {
                    let [customerId, offerType, questionIdx] = key.split('-');
                    if (typeof this.props.healthQuestions.additionalQuestions[customerId] === "undefined") {
                        this.props.healthQuestions.additionalQuestions[customerId] = {}
                    }
                    if (typeof this.props.healthQuestions.additionalQuestions[customerId][offerType] === "undefined") {
                        this.props.healthQuestions.additionalQuestions[customerId][offerType] = {
                            'questionLists': [],
                            'kt': this.props.customerId
                        }
                    }
                    this.props.healthQuestions.additionalQuestions[customerId][offerType]['questionLists'].push(questionIdx)
                }
            }
        } else if (this.props.healthQuestions.additionalQuestions === undefined) {
            this.props.healthQuestions.additionalQuestions = {}
        }
    }

    componentDidMount() {

        if (!this.props.healthQuestions.isFetching) {
            this.props.healthQuestions.results[this.props.offerType].map((qOverGroup) => {
                qOverGroup.value.question_groups.map((qg) => {
                    let groupTitle = qg.title;
                    qg.questions.map((ques) => {
                        if (ques.type === "question_block" && (ques.value.question_type === "checkbox" || ques.value.question_type === "checkboxes") && !ques.value.display_condition.includes("must check")) {
                            let checkboxAnswers = [];
                            // If the questions have already been answered, the values are added here rather than the default "false" values
                            if (this.props.healthQuestions.data && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][ques.id]) {
                                ques.value.questions.map((q) => {
                                    let accessor = q
                                    if (q.value) {
                                        accessor = q.value
                                    }
                                    return this.props.healthQuestions.data[this.props.customerId][this.props.offerType][ques.id].forEach(function (item) {
                                        if (item[accessor.label]) {
                                            checkboxAnswers.push({ [accessor.label]: item[accessor.label] })
                                        }
                                    })
                                })
                            } else {
                                ques.value.questions.map((q) => {
                                    let accessor = q
                                    if (q.value) {
                                        accessor = q.value
                                    }
                                    checkboxAnswers.push({ [accessor.label]: "false" })
                                })
                            }
                            this.props.dispatch(setQuestionAnswer({ key: ques.id, value: checkboxAnswers }, this.props.customerId, this.props.offerType, ques.value.subgroup, groupTitle))
                        }
                    })

                })
            })
        }

        if (this.props.infoCollection["smokerstatus"]) {
            let smokerAnswer = ''
            switch (this.props.infoCollection["smokerstatus"]) {
                case "NonSmokerMin10Years":
                    smokerAnswer = "Ég hef verið reyklaus í að minnsta kosti 10 ár"
                    break;
                case "NonSmokerMin1Year":
                    smokerAnswer = "Ég hef verið reyklaus í að minnsta kosti 1 ár"
                    break;
                case "Smoker":
                    smokerAnswer = "Ég er reykingamaður"
                    break;
            }
            this.props.dispatch(setQuestionAnswer({ key: "be6d5088-6e06-48a2-aa90-0e43a5ff2703", value: smokerAnswer }, this.props.customerId, "RISLEB", "", "Líftrygging - Heilsufarsspurningar"))
            if (this.props.offerType === "RISLEB") {
                let newDisabled = this.state.disabledQuestions
                newDisabled.push('be6d5088-6e06-48a2-aa90-0e43a5ff2703')
                this.setState({ disabledQuestions: newDisabled })
            }
        }

        // if (!this.props.infoCollection["VIDonetime"]) {
        //     this.props.dispatch(setQuestionAnswer({ key: "491ca368-61b1-4d37-a352-a277fe81468b", value: "Reglulegra tekna af starfi" }, this.props.customerId, "VID", "", "Upplýsingasöfnun um uppruna fjármuna eða eigna"))
        //     this.props.dispatch(setQuestionAnswer({ key: "491ca368-61b1-4d37-a352-a277fe81468b-0", value: "" }, this.props.customerId, "VID", "", "Upplýsingasöfnun um uppruna fjármuna eða eigna"))
        // }


        let that = this;
        $(`div[id^='collapse-${that.props.customerId}'`).on('hidden.bs.collapse', function () {
            let dispatchQuestionCheck = true;
            that.props.healthQuestions.results[that.props.offerType].map((offerGroup) => {

                let questionGroup = offerGroup.value.question_groups.find(item => item.title === $(this).attr('name'))
                if (questionGroup) {
                    areHealthQuestionsConfirmed(questionGroup, that.props.infoCollection, that.props.healthQuestions, that.props.customerId, that.props.offerType, that.props.offers, dispatchQuestionCheck)
                }
            })
        })

        this.updateOtherDeathBenefitsSum()
        this.reEvaluateShowStopper()
    }

    reEvaluateShowStopper(answerOverrides = null) {
        const showStopperConditions = new Set([
            "true=show_stopper",
            "false=show_stopper",
            "true=show_stopper_origin",
            "false=show_stopper_origin",
        ])

        const offerResults = this.props.healthQuestions.results && this.props.healthQuestions.results[this.props.offerType]
        const persistedOfferAnswers = this.props.healthQuestions.data
            && this.props.healthQuestions.data[this.props.customerId]
            && this.props.healthQuestions.data[this.props.customerId][this.props.offerType]
        const offerAnswers = {
            ...(persistedOfferAnswers || {}),
            ...(answerOverrides || {}),
        }

        let shouldShowStopper = false
        let stopperType = "default"

        if (offerResults && offerResults.length > 0) {
            offerResults.forEach((offerGroup) => {
                if (!offerGroup || !offerGroup.value || !offerGroup.value.question_groups) {
                    return
                }
                offerGroup.value.question_groups.forEach((questionGroup) => {
                    if (!questionGroup || !questionGroup.questions) {
                        return
                    }
                    questionGroup.containsShowStopper = false
                    questionGroup.questions.forEach((question) => {
                        if (!question || question.type !== "question_block" || !question.value) {
                            return
                        }

                        const rawAnswer = offerAnswers[question.id]
                        const hasAnswer = !(rawAnswer === undefined || rawAnswer === null || rawAnswer === "")

                        // 1) Re-evaluate show stopper conditions declared on the question itself.
                        const dispCond = question.value.display_condition
                        if (hasAnswer && showStopperConditions.has(dispCond)) {
                            let answerIsTrue = (rawAnswer === true || String(rawAnswer) === "true")
                            if (Array.isArray(rawAnswer)) {
                                answerIsTrue = rawAnswer.some((item) => {
                                    if (!item || typeof item !== "object") {
                                        return false
                                    }
                                    const value = Object.values(item)[0]
                                    return value === true || String(value) === "true"
                                })
                            }
                            const isTrueCondition = dispCond.indexOf("true=") === 0
                            const isTriggered = isTrueCondition ? answerIsTrue : !answerIsTrue

                            if (isTriggered) {
                                shouldShowStopper = true
                                if (dispCond.indexOf("_origin") > -1) {
                                    stopperType = "origin"
                                }
                                questionGroup.containsShowStopper = true
                            }
                        }

                        // 2) Re-evaluate show stopper conditions declared on selected option actions.
                        if (
                            hasAnswer
                            && question.value.question_type === "radio"
                            && Array.isArray(question.value.questions)
                        ) {
                            question.value.questions.forEach((q) => {
                                let accessor = q
                                if (q && q.value) {
                                    accessor = q.value
                                }

                                if (!accessor || String(accessor.label) !== String(rawAnswer)) {
                                    return
                                }

                                const action = accessor.action
                                if (
                                    typeof action !== "string"
                                    || action.indexOf("show_stopper") === -1
                                    || action.indexOf("portfolio") === -1
                                ) {
                                    return
                                }

                                if (this.dispCondMatchesPortfolioType(action)) {
                                    shouldShowStopper = true
                                    stopperType = "investment"
                                    questionGroup.containsShowStopper = true
                                }
                            })
                        }
                    })
                })
            })
        }

        const nextEvaluation = `${this.props.customerId}:${shouldShowStopper}:${stopperType}`
        if (nextEvaluation === this.lastShowStopperEvaluation) {
            return
        }

        this.lastShowStopperEvaluation = nextEvaluation
        this.props.dispatch(showStopper(shouldShowStopper ? "true" : "false", this.props.customerId, shouldShowStopper ? stopperType : "default"))
    }

    updateOtherDeathBenefitsSum() {
        if (typeof document === 'undefined') {
            return
        }
        const parent = "#accordion-" + this.props.customerId + "-" + this.props.offerType;
        const cols = document.querySelectorAll(parent+' div.other_death_benefits .answers .col:nth-child(2)')
        const total = Array.from(cols).reduce((sum, col) => {
            const value = parseInt(col.textContent.replace(/\D+/g, ''), 10)
            return sum + (Number.isNaN(value) ? 0 : value)
        }, 0)

        if (total !== this.state.otherDeathBenefitsSum) {
            this.setState({ otherDeathBenefitsSum: total })
        }
    }

	onCheckboxChange(e, key) {
        const { name, checked } = e.currentTarget;
        let checkedQ = this.state.checkedQ;
        let additionalQuestionsSet = this.state.additionalQuestionsSet;

        checkedQ[key] = checked;
        additionalQuestionsSet = true;
		this.setState({ checkedQ, additionalQuestionsSet});
	}    

    getOfferType(offerType) {
        let _offerType = '';
        if (['FORD', 'REND'].includes(offerType)) {
            _offerType = offerType.substring(0, offerType.length - 1)
        } else {
            _offerType = offerType
        }
        return _offerType
    }

    addAnswerToOtherCustInsurances(questionId, answer, subgroup, groupTitle, dispCond) {
        Object.values(this.props.allInfoCollection.data).map((person) => {
            if (this.props.allQueryParams[person.customerId]) {
                Object.keys(this.props.allQueryParams[person.customerId]).map((insuranceType) => {
                    if (this.props.allQueryParams[person.customerId][insuranceType] === true) {
                        let _insuranceType = insuranceType;
                        if (person['age'] < 18 && insuranceType === 'FOR') {
                            _insuranceType = 'REN'
                        }
                        if ((person[`${_insuranceType}insuranceTaker`] && person[`${_insuranceType}insuranceTaker`] === this.props.customerId) && !(((insuranceType === 'VID' && this.props.allInfoCollection.data[person.customerId].VIDonetime) || ((insuranceType === 'REN' || insuranceType === 'FOR' || insuranceType === 'REND' || insuranceType === 'FORD') && this.props.allInfoCollection.data[person.customerId].RENtype === 'onetime')) && (dispCond === 'if NOT single payment'))) {
                            this.props.dispatch(setQuestionAnswer({ key: questionId, value: answer }, person.customerId, insuranceType, subgroup, groupTitle))
                        }
                    }
                })
            }
        })
    }

    isSinglePayment(dispCond) {
        let singlePayment = false;
        if (dispCond === "if single payment" && ((this.props.offerType === 'VID' && this.props.infoCollection.VIDonetime) || ((this.props.offerType === 'REN' || this.props.offerType === 'FOR' || this.props.offerType === 'REND' || this.props.offerType === 'FORD') && this.props.infoCollection.RENtype === 'onetime'))) {
            singlePayment = true;
        }
        return singlePayment
    }

    selectAnswer(canBeCopied, questionId, dispCond, subgroup, groupTitle, e) {
        this.props.dispatch(setQuestionAnswer({ key: questionId, value: e.target.value }, this.props.customerId, this.props.offerType, subgroup, groupTitle))
        this.reEvaluateShowStopper({ [questionId]: String(e.target.value) })
        if (!this.isSinglePayment(dispCond)) {
            if (questionId in this.props.healthQuestions.questionAccountant) {
                this.props.healthQuestions.questionAccountant[questionId].map((offerType) => {

                    let _offerType = this.getOfferType(offerType);

                    if (this.props.offerQueryParams[_offerType] === true) {
                        this.props.dispatch(setQuestionAnswer({ key: questionId, value: e.target.value }, this.props.customerId, offerType, subgroup, groupTitle))
                    }
                })
            }
            if (questionId.charAt(questionId.length - 2) === "-") {
                let qId = questionId.substring(0, questionId.length - 2);
                if (qId in this.props.healthQuestions.questionAccountant) {
                    this.props.healthQuestions.questionAccountant[qId].map((offerType) => {

                        let _offerType = this.getOfferType(offerType);

                        if (this.props.offerQueryParams[_offerType] === true) {
                            this.props.dispatch(setQuestionAnswer({ key: questionId, value: e.target.value }, this.props.customerId, offerType, subgroup, groupTitle))
                        }
                    })
                }
            }
            if (canBeCopied) {
                let answer = e.target.value;
                this.addAnswerToOtherCustInsurances(questionId, answer, subgroup, groupTitle, dispCond)
            }
        }
    }

    selectCheckboxAnswer(questions, canBeCopied, type, label, questionId, dispCond, subgroup, groupTitle, e) {
        let disable_other_options_label = null;

        questions.map((q) => {
            let accessor = q
            if (q.value) {
                accessor = q.value
            }
            if (accessor.action && accessor.action === 'disable_other_options') {
                disable_other_options_label = accessor.label
            }
        })

        let checkboxAnswers = [];
        if (dispCond.includes("must check")) {
            questions.map((q) => {
                let accessor = q
                if (q.value) {
                    accessor = q.value
                }
                checkboxAnswers.push({ [accessor.label]: e.currentTarget.checked.toString() })
            })
        } else {
            checkboxAnswers = this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId];
        }

        let newCheckboxAnswers = checkboxAnswers.map((l) => {
            if (Object.keys(l)[0] === label) {
                return ({ [Object.keys(l)[0]]: e.currentTarget.checked.toString() })
            } else {
                return ({ [Object.keys(l)[0]]: Object.values(l)[0] })
            }
        })

        if (disable_other_options_label && newCheckboxAnswers.find(f => Object.keys(f)[0] === disable_other_options_label)) {
            let answer = newCheckboxAnswers.find(f => Object.keys(f)[0] === disable_other_options_label)
            let answerIndex = newCheckboxAnswers.findIndex(f => Object.keys(f)[0] === disable_other_options_label)
            let key = e.target.id
            
            if (answer[disable_other_options_label] === 'true') {
                newCheckboxAnswers = newCheckboxAnswers.map((l) => {
                    if (Object.keys(l)[0] !== disable_other_options_label ) {
                        return ({ [Object.keys(l)[0]]: 'false' })
                    } else {
                        return ({ [Object.keys(l)[0]]: 'true' })
                    }
                })
                $(`[name*="${key.replace('-'+answerIndex, '-')}"]`).not(`[name="${key}"]`).attr('disabled', true)
            } else {
                $(`[name*="${key.replace('-'+answerIndex, '-')}"]`).not(`[name="${key}"]`).attr('disabled', false)
            }
        }

        this.props.dispatch(setQuestionAnswer({ key: questionId, value: newCheckboxAnswers }, this.props.customerId, this.props.offerType, subgroup, groupTitle))
        this.reEvaluateShowStopper({ [questionId]: newCheckboxAnswers })
        if (!this.isSinglePayment(dispCond)) {
            this.props.healthQuestions.questionAccountant[questionId].map((offerType) => {
                let _offerType = this.getOfferType(offerType);

                if (this.props.offerQueryParams[_offerType] === true) {
                    this.props.dispatch(setQuestionAnswer({ key: questionId, value: newCheckboxAnswers }, this.props.customerId, offerType, subgroup, groupTitle))
                }
            })
            if (canBeCopied) {
                let answer = newCheckboxAnswers;
                this.addAnswerToOtherCustInsurances(questionId, answer, subgroup, groupTitle, dispCond)
            }
        }

    }

    checkSustainabilityAnswers(portfolio) {
        this.reEvaluateShowStopper()
    }

    selectRadioAnswer(canBeCopied, questionId, dispCond, accessor, subgroup, groupTitle, e) {
        // ---- 
        // For sustainability only

        let key = questionId

        if (accessor.action && accessor.action.includes('portfolio')) {

            // key = `${questionId}-${this.props.infoCollection[this.props.offerType + 'Portfolio']}`

            let isShowStopper = this.dispCondMatchesPortfolioType(accessor.action)
            this.setState({
                ...this.state,
                portfolioAnswers: {
                    ...this.state.portfolioAnswers,
                    [this.props.infoCollection[this.props.offerType + 'Portfolio']]: {
                        ...this.state.portfolioAnswers[this.props.infoCollection[this.props.offerType + 'Portfolio']],
                        [questionId]: isShowStopper
                    }
                },
                sustainabilitycheck: {
                    ...this.state.sustainabilitycheck,
                    [this.props.customerId]: {
                        [questionId]: isShowStopper
                    }
                }
            }, () => {
                this.checkSustainabilityAnswers(this.props.infoCollection[this.props.offerType + 'Portfolio'])
            })
            // if (this.dispCondMatchesPortfolioType(accessor.action)) {
            //     console.log("Show stopper - true")
            //     this.props.dispatch(showStopper('true', this.props.customerId))
            //     this.props.dispatch(setQuestionAnswer({ key: "44348c09-b7b6-404f-a088-7c6ebf8617a0", value: 'false' }, this.props.customerId, this.props.offerType, subgroup, groupTitle))
            // } else {
            //     console.log("Show stopper - false")
            //     this.props.dispatch(showStopper('false', this.props.customerId))
            //     this.props.dispatch(setQuestionAnswer({ key: "44348c09-b7b6-404f-a088-7c6ebf8617a0", value: 'true' }, this.props.customerId, this.props.offerType, subgroup, groupTitle))
            // }
        }

        this.props.dispatch(setQuestionAnswer({ key: key, value: e.target.value }, this.props.customerId, this.props.offerType, subgroup, groupTitle))
        this.reEvaluateShowStopper({ [key]: String(e.target.value) })

        // Also this? 
        if (!this.isSinglePayment(dispCond)) {
            if (questionId in this.props.healthQuestions.questionAccountant) {
                this.props.healthQuestions.questionAccountant[questionId].map((offerType) => {

                    let _offerType = this.getOfferType(offerType);

                    if (this.props.offerQueryParams[_offerType] === true) {
                        this.props.dispatch(setQuestionAnswer({ key: questionId, value: e.target.value }, this.props.customerId, offerType, subgroup, groupTitle))
                    }
                })
            }
            if (questionId.charAt(questionId.length - 2) === "-") {
                let qId = questionId.substring(0, questionId.length - 2);
                if (qId in this.props.healthQuestions.questionAccountant) {
                    this.props.healthQuestions.questionAccountant[qId].map((offerType) => {

                        let _offerType = this.getOfferType(offerType);

                        if (this.props.offerQueryParams[_offerType] === true) {
                            this.props.dispatch(setQuestionAnswer({ key: questionId, value: e.target.value }, this.props.customerId, offerType, subgroup, groupTitle))
                        }
                    })
                }
            }
            if (canBeCopied) {
                let answer = e.target.value;
                this.addAnswerToOtherCustInsurances(questionId, answer, subgroup, groupTitle, dispCond)
            }
        }
        // --- 
    }

    renderRadioQ(canBeCopied, questions, questionId, dispCond, subgroup, groupTitle) {
        let radioButtons = questions.map((q, i) => {
            let accessor = q
            if (q.value) {
                accessor = q.value
            }
            return (
                <div key={`${questionId}-${accessor.label || i}`} className="radio">
                    <input
                        disabled={this.state.disabledQuestions.includes(questionId)}
                        type="radio"
                        id={this.props.customerId + "-" + "-" + this.props.offerType + "-" + questionId + '-' + i}
                        checked={this.shouldBeChecked(questionId, accessor.label, "radio")}
                        name={this.props.customerId + "-" + "-" + this.props.offerType + "-" + questionId + '-' + i}
                        value={accessor.label}
                        onChange={(e) => this.selectRadioAnswer(canBeCopied, questionId, dispCond, accessor, subgroup, groupTitle, e)}></input>
                    <label htmlFor={this.props.customerId + "-" + "-" + this.props.offerType + "-" + questionId + '-' + i}>{accessor.label}</label>
                </div>
            )
        })
        return radioButtons
    }

    renderCheckboxQ(questions, questionId, dispCond, subgroup, groupTitle, type, canBeCopied) {
        let radioButtons = questions.map((q, i) => {
            let accessor = q
            if (q.value) {
                accessor = q.value
            }

            return (
                <div key={`${questionId}-${accessor.label || i}`} className="checkbox">
                    <input type="checkbox" id={this.props.customerId + "-" + this.props.offerType + "-" + questionId + '-' + i} checked={this.shouldBeChecked(questionId, accessor.label, type)} name={this.props.customerId + "-" + this.props.offerType + "-" + questionId + '-' + i} value={accessor.label} onChange={(e) => this.selectCheckboxAnswer(questions, canBeCopied, type, accessor.label, questionId, dispCond, subgroup, groupTitle, e)}></input>
                    <label htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + questionId + '-' + i}>{accessor.label}</label>
                </div>
            )
        })
        return radioButtons
    }

    addMultiAnswer(questionType, answer, questionId, subgroup, groupTitle, canBeCopied, dispCond) {
        let oldArr = [];
        if (this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId]) {
            oldArr = this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId]
        }
        oldArr.push(answer)
        this.props.dispatch(setQuestionAnswer({ key: questionId, value: oldArr }, this.props.customerId, this.props.offerType, subgroup, groupTitle))

        if (!this.isSinglePayment(dispCond)) {
            if (questionId in this.props.healthQuestions.questionAccountant) {
                this.props.healthQuestions.questionAccountant[questionId].map((offerType) => {

                    let _offerType = this.getOfferType(offerType);
                    if (this.props.offerQueryParams[_offerType] === true) {
                        this.props.dispatch(setQuestionAnswer({ key: questionId, value: oldArr }, this.props.customerId, offerType, subgroup, groupTitle))
                    }
                })
            }
            if (canBeCopied) {
                let answer = oldArr;
                this.addAnswerToOtherCustInsurances(questionId, answer, subgroup, groupTitle, dispCond);
            }
        }
    }

    getConditionalQValue(questionId, i) {
        if (this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-" + i]) {
            return this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-" + i]
        } else {
            return ""
        }
    }

    renderConditionalQuestion(canBeCopied, conditions, question, subgroup, groupTitle, questions, type, dispCond) {
        let lastValueInArray = questions[questions.length - 1].label;

        let allConditionalQuestions = conditions.map((condition, index) => {
            let conditionAccessor = condition.condition
            if (condition.value) {
                conditionAccessor = condition.value.condition
            }
            if (
                (type === "checkbox" && (
                    (conditionAccessor === "anyTrue" &&
                        this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] &&
                        this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id].find(e => Object.keys(e)[0] === lastValueInArray && Object.values(e)[0] === "true")
                    ) ||
                    (conditionAccessor === "anyFalse" &&
                        this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] &&
                        this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id].find(e => Object.values(e) === "false")
                    ) ||
                    (conditionAccessor === "lastTrue" &&
                        this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] &&
                        Object.values(this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id].slice(-1)[0])[0] === "true"))
                ) ||
                (conditionAccessor === "anyTrue" &&
                    this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] &&
                    this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] === 'true'
                ) ||
                (conditionAccessor === "anyFalse" &&
                    this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] &&
                    this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] === 'false'
                ) ||
                (conditionAccessor === "lastTrue" &&
                    this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] &&
                    this.props.healthQuestions.data[this.props.customerId][this.props.offerType][question.id] === lastValueInArray
                )
            ) {
                let accessor = condition.conditional_question
                if (condition.value) {
                    accessor = condition.value.conditional_question
                }

                return (
                    accessor.map((c, i) => {
                        if (c.type === "conditional_checkboxes") {
                            return (<div key={`${question.id}-${i}-conditional-checkboxes`} className={`qa conditional-checkboxes${this.isQuestionUnanswered(question.id + "-" + i, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                                <div className="answer radio">
                                    {c.value.map(((val, ind) => {
                                        let condAccessor = val
                                        if (val.value) {
                                            condAccessor = val.value
                                        }
                                        return (<div key={`${question.id}-${i}-${condAccessor.label || ind}`} className="radio">
                                            <input
                                                type="radio"
                                                id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i + "-" + ind}
                                                checked={this.shouldBeChecked(question.id + "-" + i, condAccessor.label)}
                                                name={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i}
                                                value={condAccessor.label}
                                                onChange={(e) => this.selectAnswer(canBeCopied, question.id + "-" + i, dispCond, subgroup, groupTitle, e)}></input>
                                            <label htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i + "-" + ind}>{condAccessor.label}</label>
                                        </div>)
                                    }))}
                                </div>
                            </div>)
                        } else if (c.type === "conditional_multi") {
                            let conditionalQuestion = true;
                            return (
                                <React.Fragment key={`${question.id}-${i}-conditional-multi`}>
                                {this.renderMultiQuestionAnswers(question, subgroup, groupTitle, conditionalQuestion)}
                                <div className={`qa conditional-button${this.isQuestionUnanswered(question.id + "-" + i, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                                    <label className="question" >{question.label}</label>
                                    <button className="btn btn-primary answer" data-toggle="modal" onClick={(e) => e.preventDefault()} data-target={"#MultiAnsModal-" + this.props.customerId + "-" + question.id}>Bæta við</button>
                                </div>
                                <MultiAnsModal id={"MultiAnsModal-" + this.props.customerId + "-" + question.id} question={c} customerId={this.props.customerId} offerType={this.props.offerType} addMultiAnswer={this.addMultiAnswer} subgroup={subgroup} groupTitle={groupTitle} store={this.props.store} conditionalQuestion={true} questionId={question.id} canBeCopied={canBeCopied} dispCond={dispCond} />
                                </React.Fragment>)
                        } else if (c.type === "conditional_yes_no") {
                            return (
                                <div key={`${question.id}-${i}-conditional-yes-no`} className={`qa conditional-yes-no${this.isQuestionUnanswered(question.id + "-" + i, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                                    <div className="question-wrapper">
                                        <div className="question">{c.value.label}</div>
                                        <div className="answer yes-and-no">
                                            <div>
                                                <input type="radio" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i + "-yes"} checked={this.shouldBeChecked(question.id + "-" + i, "true")} name={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i} value={true} onChange={(e) => this.selectAnswer(canBeCopied, question.id + "-" + i, dispCond, subgroup, groupTitle, e)}></input>
                                                <label htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i + "-yes"}>Já</label>
                                            </div>
                                            <div>
                                                <input type="radio" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i + "-no"} checked={this.shouldBeChecked(question.id + "-" + i, "false")} name={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i} value={false} onChange={(e) => this.selectAnswer(canBeCopied, question.id + "-" + i, dispCond, subgroup, groupTitle, e)}></input>
                                                <label htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + i + "-no"}>Nei</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        } else if (c.type === "conditional_lookup") {
                            return (<SsnLookup key={`${question.id}-${i}-conditional-lookup`} conditionalLookup={true} question={c} customerId={this.props.customerId} offerType={this.props.offerType} dispCond={dispCond} selectAnswer={this.selectAnswer} mainQuestionId={question.id} subgroup={subgroup} groupTitle={groupTitle} />)
                        } else if (c.type === "conditional_text") {
                            return (
                                <div key={`${question.id}-${i}-conditional-text`} className={`qa conditional-input${this.isQuestionUnanswered(question.id + "-" + i, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                                    <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + '-' + i}>{c.value.label}</label>
                                </div>
                            )
                        } else {
                            return (
                                <div key={`${question.id}-${i}-conditional-input`} className={`qa conditional-input${this.isQuestionUnanswered(question.id + "-" + i, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                                    <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + '-' + i}>{c.value.label}</label>
                                    <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + '-' + i} onChange={(e) => this.selectAnswer(canBeCopied, question.id + "-" + i, dispCond, subgroup, groupTitle, e)} value={this.getConditionalQValue(question.id, i)}></input>
                                </div>
                            )
                        }
                    })
                )
            }
        })
        return allConditionalQuestions;
    }

    shouldBeChecked(questionId, condition, type) {
        let checked = false;
        if (this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId]) {
            if (this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId] === condition) {
                checked = true
            }
            if (type && type === "checkboxes" || type === "checkbox") {
                this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId].map((q) => {
                    let accessor = q
                    if (accessor.value) {
                        accessor = q.value
                    }
                    if (Object.keys(accessor)[0] === condition && Object.values(accessor)[0] === "true") {
                        checked = true
                    }
                })
            }
        }
        return checked
    }

    singleLineValue(questionId) {
        if (this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId]) {
            return this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId]
        } else {
            return ""
        }
    }

    // anyAnswerInGroupTrue(groupCond, groupTitle) {
    //     let values = []
    //     if (this.props.healthQuestions.groups[this.props.customerId] && this.props.healthQuestions.groups[this.props.customerId][this.props.offerType] && this.props.healthQuestions.groups[this.props.customerId][this.props.offerType][groupTitle] && this.props.healthQuestions.groups[this.props.customerId][this.props.offerType][groupTitle][groupCond]) {
    //         Object.values(this.props.healthQuestions.groups[this.props.customerId][this.props.offerType][groupTitle][groupCond]).map((val) => {
    //             values.push(val)
    //         })
    //     }
    //     return values.includes("true")
    // }

    renderMultiAnsQuestionBtn(question, subgroup, groupTitle, canBeCopied, dispCond) {
        let multiAns = <>
            <div className="qa button">
                <label className="question">{question.value.title}</label>
                <button className="btn btn-primary answer" data-toggle="modal" onClick={(e) => e.preventDefault()} data-target={"#MultiAnsModal-" + this.props.customerId + "-" + question.id}>Bæta við</button>
            </div>
            <MultiAnsModal id={"MultiAnsModal-" + this.props.customerId + "-" + question.id} question={question} customerId={this.props.customerId} offerType={this.props.offerType} addMultiAnswer={this.addMultiAnswer} subgroup={subgroup} groupTitle={groupTitle} store={this.props.store} conditionalQuestion={false} questionId={question.id} canBeCopied={canBeCopied} dispCond={dispCond} /></>

        return multiAns
    }

    removeLine(answer, allMultiAnswers, questionId, subgroup, groupTitle) {
        let newMultiAnswers = []
        allMultiAnswers.map((a) => {
            if (a !== answer) {
                newMultiAnswers.push(a)
            }
            return newMultiAnswers
        })

        this.props.dispatch(setQuestionAnswer({ key: questionId, value: newMultiAnswers }, this.props.customerId, this.props.offerType, subgroup, groupTitle))
    }

    renderConditionalMultiAnswer(a) {
        let conditionalMultiAns = []
        if (a === false || a === true) {
            conditionalMultiAns = <div className="col"><span className={a === true ? "checked" : ""}></span></div>
        } else {
            conditionalMultiAns = <div className="col">{a}</div>
        }
        return conditionalMultiAns
    }

    renderMultiQuestionAnswers(question, subgroup, groupTitle, conditionalQuestion) {
        let questionId = "";
        if (conditionalQuestion) {
            questionId = question.id + "-0";
        } else {
            questionId = question.id;
        }

        let allMultiQAns = [];
        if (this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId]) {
            if (conditionalQuestion) {
                let accessor = question.value.conditions[0]
                if (question.value.conditions[0].value) {
                    accessor = question.value.conditions[0].value.conditional_question[0]
                }
                // if we have conditionalQuestion we have a conditional_multi in the source
                // in which case the structurce of accessor is:
                // {id, type, value: {block_html_id, condition, questions}}
                const blockHtmlClass = accessor.value.block_html_class  ;
                allMultiQAns = <>
                    <div className="label-container">
                        {accessor.value.questions.map((q, idx) => {
                            return (<div key={`${questionId}-label-${idx}`} className="col">{q.label}</div>)
                        })
                        }
                    </div>
                    <div 
                        className={`answers-container${blockHtmlClass ? ' '+blockHtmlClass :''}`}>

                        {this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId].map((answer, answerIdx) => {
                            let answers = <div key={`${questionId}-answer-${answerIdx}`} className="answers">{answer.map((a, idx) => { return (<React.Fragment key={`${questionId}-cell-${answerIdx}-${idx}`}>{this.renderConditionalMultiAnswer(a)}</React.Fragment>) })}<button onClick={this.removeLine.bind(this, answer, this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId], questionId, subgroup, groupTitle)}><SvgTrashIcon /></button></div>
                            return (answers)
                        })
                        }
                    </div>
                </>
            } else {
                allMultiQAns = <>
                    <div className="label-container">
                        {question.value.questions.map((q, idx) => {
                            return (<div key={`${questionId}-label-${idx}`} className="col">{q.label}</div>)
                        })
                        }
                    </div>
                    <div className="answers-container">
                        {this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId].map((answer, answerIdx) => {
                            let answers = <div key={`${questionId}-answer-${answerIdx}`} className="answers">{answer.map((a, idx) => { return (<div key={`${questionId}-cell-${answerIdx}-${idx}`} className="col">{a}</div>) })}<button onClick={this.removeLine.bind(this, answer, this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId], questionId, subgroup, groupTitle)}><SvgTrashIcon /></button></div>
                            return (answers)
                        })
                        }
                    </div>
                </>
            }
        }

        return allMultiQAns;
    }

    onChangeSelectValue(e, questionId, subgroup, groupTitle) {
        this.props.dispatch(setQuestionAnswer({ key: questionId, value: e.target.value }, this.props.customerId, this.props.offerType, subgroup, groupTitle))
    }

    onChangeLookupValue(e, questionId, index, subgroup, groupTitle, tableName, tableLine, tableId, tableProp) {
        this.onChangeSelectValue(e, questionId + "-" + index, subgroup, groupTitle)
    }

    // Gets fund table
    getTable(data, customerId, id, index, subgroup, groupTitle) {
        let { tableName, tableLine, tableId, tableProp, tableFilter } = data
        if (tableFilter === undefined) {
            tableFilter = (f) => f
        }
        let table = this.props[tableProp]
        let val = ""
        if (this.props.healthQuestions.data && this.props.healthQuestions.data[customerId] && this.props.healthQuestions.data[customerId] && this.props.healthQuestions.data[customerId][this.props.offerType] && this.props.healthQuestions.data[customerId][this.props.offerType][id + "-" + index]) {
            val = this.props.healthQuestions.data[customerId][this.props.offerType][id + "-" + index]
        }
        let all = <select className="custom-select col-12 col-sm-6" id={`${data.title}-${customerId}`} name={data.title} onChange={(e) => this.onChangeLookupValue(e, id, index, subgroup, groupTitle, tableName, tableLine, tableId, tableProp)} value={val} disabled={false} >
            <option value="">---</option>
            {table.data && !table.isFetching && table.data[tableName][tableLine].filter(tableFilter).map((item) => {
                return (<option key={`${data.title}-${item[tableId]}`} value={item[tableId]}>{item.Name}</option>)
            })}
        </select>
        return all
    }


    renderLookupDropdown(questions, id, subgroup, groupTitle) {
        let customerId = this.props.customerId
        return questions.map((q, index) => {
            let accessor = q
            if(q.value) {
                accessor = q.value
            }
            let data = this.state[accessor.label]
            return <div key={`${id}-${accessor.label || index}`} className="form-row align-items-center mb-2 mt-3">
                <div className="col-sm-8">
                    <label htmlFor={`${data.title}-${customerId}`} className="col-form-label">{data.title}</label>
                </div>
                <div className="col-sm-4 text-right">
                    {this.getTable(data, customerId, id, index, subgroup, groupTitle)}
                </div>
            </div>
        })
    }

    isQuestionUnanswered(questionId, customerId, offerType, groupTitle, subGroup) {
        if ((this.props.healthQuestions.answeredQuestions && this.props.healthQuestions.answeredQuestions[customerId] && this.props.healthQuestions.answeredQuestions[customerId][offerType] && this.props.healthQuestions.answeredQuestions[customerId][offerType][groupTitle] && Object.keys(this.props.healthQuestions.answeredQuestions[customerId][offerType][groupTitle]).includes(questionId))) {
            if (this.props.healthQuestions.answeredQuestions[customerId][offerType][groupTitle][questionId] === true || (this.props.healthQuestions.groups && this.props.healthQuestions.groups[customerId] && this.props.healthQuestions.groups[customerId][offerType] && this.props.healthQuestions.groups[customerId][offerType][groupTitle] && this.props.healthQuestions.groups[customerId][offerType][groupTitle][subGroup] && this.props.healthQuestions.groups[customerId][offerType][groupTitle][subGroup][questionId])) {
                return false
            } else {
                return true
            }

        }
        return false
    }

    getKeyFigure(name) {
        const _offerType = this.getOfferType(this.props.offerType);
        if (_offerType in this.props.offers.offers[this.props.customerId]) {
            return parseFloat(this.props.offers.offers[this.props.customerId][_offerType].keyFigures[name])
        } else {
            return 0;
        }
    }

    dispCondMatchesOfferType(dispCond) {
        var l = dispCond.split(' ');
        if (l.includes('offer_type')) {
            if (l.includes('!=')) {
                return !l[3].includes(this.props.offerType)
            }
            else if (l.includes('==')) {
                let offers = l[3]
                if (l[3].includes(',')) {
                    offers = l[3].split(',')
                    return offers.includes(this.props.offerType)
                }
                return offers === this.props.offerType
            }
            else { return false }
        }
        return false
    }


    dispCondMatchesPortfolioType(dispCond) {
        const offerType = this.props.offerType === 'FOR' ? 'REN' : this.props.offerType
        const kd_percentage = dispCond.includes("komfortdynamik_60") || dispCond.includes("komfortdynamik_80") 
        if (!kd_percentage && dispCond.includes("perspektive") && dispCond.includes("komfortdynamik")) {
            return true
        }

        let returnvalue = false;

        if (!kd_percentage && dispCond.includes("komfortdynamik")) {
            return this.props.infoCollection[offerType + 'Portfolio'] === 'komfortdynamik'
        } else if (kd_percentage) {
            const combined = this.props.infoCollection[offerType + 'Portfolio'] + '_' + this.props.infoCollection[offerType + 'KDpercentage']
            returnvalue = dispCond.includes(combined)
        }

        if (!returnvalue && dispCond.includes("perspektive")) {
            returnvalue = this.props.infoCollection[offerType + 'Portfolio'] === 'perspektive'
        }

        return returnvalue
    }


    getSingleQuestion(question, groupTitle, canBeCopied) {
        const _offerType = this.getOfferType(this.props.offerType);

        let questions = question.value.questions;
        let type = question.value.question_type;
        let conditions = question.value.conditions;
        let dispCond = question.value.display_condition;
        let subgroup = question.value.subgroup;
        let onlyDispOnCondition = question.value.display_on_condition;
        let identifier = question.value.identifier;
        let total_death_benefits = this.getKeyFigure("GarantierteTodesfallleistung") || this.getKeyFigure("GarantierteTodesfallleistungUnfallTod");
        const death_benefits_upper = 500000;

        const total_others = this.state.otherDeathBenefitsSum;
        total_death_benefits = total_death_benefits  + total_others;


        // Ath. refactoraði IF-setninguna aðeins en tók ekkert út strax ef eitthvað skyldi brotna
        if (
            ((dispCond === "if single payment" || dispCond === "if NOT single payment") && contractPaymentTypeMatch(dispCond, this.props.offerType, this.props.infoCollection, this.props.customerId))

            || noSpecificDispCond(dispCond)

            || (onlyDispOnCondition && checkDisplayCondition(dispCond, groupTitle, this.props.healthQuestions, this.props.customerId, this.props.offerType))


            || (onlyDispOnCondition && this.dispCondMatchesOfferType(dispCond))
            || (onlyDispOnCondition && this.dispCondMatchesPortfolioType(dispCond))
            // || (onlyDispOnCondition && dispCond === "if offer_type != KSP, RISLEB" && (this.props.offerType !== 'KSP' || this.props.offerType !== 'RISLEB')) 
            // || (onlyDispOnCondition && dispCond === "if offer_type == VID" && (this.props.offerType === 'VID')) 
            // || (onlyDispOnCondition && dispCond === "if offer_type == VID, VIDT" && (this.props.offerType === 'VID' || this.props.offerType === 'VIDT')) 
            // || (onlyDispOnCondition && dispCond === "if offer_type == VIDT" && (this.props.offerType === 'VIDT')) 

            || (onlyDispOnCondition && dispCond.includes("yearly pension > 18000") && (this.getKeyFigure("GarantierteRente") * 12) > 18000)
            || (onlyDispOnCondition && dispCond.includes("yearly pension > 24000") && (this.getKeyFigure("GarantierteRente") * 12) > 24000)

            || (subgroup === 'C' && ['LEB', 'RISLEB'].includes(this.props.offerType) && (total_death_benefits > 200000))
            || (subgroup === 'D' && this.props.offerType === 'RISLEB' && ((total_death_benefits > death_benefits_upper) || ((total_death_benefits * parseFloat(this.props.offers.offers[this.props.customerId][_offerType].keyFigures.Wert["UZ"])) / 100 > death_benefits_upper)))
            || (subgroup === 'D' && ['FORD', 'REND', 'LEB'].includes(this.props.offerType) && (total_death_benefits > death_benefits_upper))
            || (subgroup === 'D' && this.props.offerType === 'LEB' && this.props.infoCollection['LEBunits'] === 'percentage' && (total_death_benefits * parseFloat(this.props.offers.offers[this.props.customerId][_offerType].keyFigures.Wert["UZ"]) / 100 > death_benefits_upper))
            || (subgroup === 'D' && this.props.offerType === 'LEB' && this.props.infoCollection['LEBunits'] === 'currency' && (parseFloat(this.props.offers.offers[this.props.customerId][_offerType].keyFigures.Wert["UZ"]) > death_benefits_upper))

            // || (onlyDispOnCondition && dispCond === "must check") 
            || (subgroup === 'C' && this.props.offerType === 'KSP' && isGesamtRenteHigherThanLimit(18000, _offerType, this.props.offers, this.props.customerId))) {

            let firstQuestionAccessor = null
            if (questions) {
                firstQuestionAccessor = questions[0]
                if (questions[0].value) {
                    firstQuestionAccessor = questions[0].value
                }
            }

            let toReturn = []


            if (question.type === "question_block") {
                if (type === 'yes_no') {
                    toReturn.push(
                        <div className={`qa yes-no${this.isQuestionUnanswered(question.id, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`} >
                            <div className="question-wrapper">
                                <div className="question">{firstQuestionAccessor.label}{firstQuestionAccessor.tooltip && <>&nbsp;<Tooltip text={firstQuestionAccessor.tooltip} /></>}</div>
                                <div className="answer yes-and-no">
                                    <div>
                                        <input type="radio" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-yes"} checked={this.shouldBeChecked(question.id, "true", type)} name={this.props.customerId + "-" + this.props.offerType + "-" + question.id} value={true} onChange={(e) => this.selectAnswer(canBeCopied, question.id, dispCond, subgroup, groupTitle, e)}></input>
                                        <label htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-yes"}>Já</label>
                                    </div>
                                    <div>
                                        <input type="radio" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-no"} checked={this.shouldBeChecked(question.id, "false", type)} name={this.props.customerId + "-" + this.props.offerType + "-" + question.id} value={false} onChange={(e) => this.selectAnswer(canBeCopied, question.id, dispCond, subgroup, groupTitle, e)}></input>
                                        <label htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-no"}>Nei</label>
                                    </div>
                                </div>
                            </div>
                            {firstQuestionAccessor.extra_text &&
                                <div className="extra-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(firstQuestionAccessor.extra_text.replace(/(?:\r\n|\r|\n)/g, '<br>')) }}></div>
                            }
                            {this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && conditions.length > 0 &&
                                <div className="conditionals">
                                    {this.renderConditionalQuestion(canBeCopied, conditions, question, subgroup, groupTitle, questions, "yes_no", dispCond)}
                                </div>
                            }
                        </div>
                    )
                } else if (type === "singleline" || type === 'singlelineEUR') {
                    if (question.value.title !== "" && question.value.questions.length > 1) {
                        toReturn.push(<>
                            <div className="question-title">{question.value.title}</div>
                            <div className="qa singleline multiple-qa">
                                {question.value.questions.map((q, index) => {
                                    return (
                                        <React.Fragment key={`${question.id}-${index}`}>
                                            <label className={`question${this.isQuestionUnanswered(question.id + "-" + index, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`} htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + index}>{q.value.label}{q.value.tooltip && <>&nbsp;<Tooltip text={q.value.tooltip} /></>}</label>
                                            <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + index} onChange={(e) => this.selectAnswer(canBeCopied, question.id + "-" + index, dispCond, subgroup, groupTitle, e)} value={this.singleLineValue(question.id + "-" + index)}></input>
                                        </React.Fragment>)
                                })}
                            </div>
                        </>)
                    } else {
                        toReturn.push(
                            <div className={`qa singleline${this.isQuestionUnanswered(question.id, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''} ${type === "singlelineEUR" ? ' currency' : ''}`}>
                                <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id}>{firstQuestionAccessor.label}{firstQuestionAccessor.tooltip && <>&nbsp;<Tooltip text={firstQuestionAccessor.tooltip} /></>}</label>
                                <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id} onChange={(e) => this.selectAnswer(canBeCopied, question.id, dispCond, subgroup, groupTitle, e)} value={this.singleLineValue(question.id)}></input>
                            </div>
                        )
                    }
                } else if (type === "multiline") {
                    if (question.value.title !== "" && question.value.questions.length > 1) {
                        toReturn.push(<>
                            <div className="question-title">{question.value.title}</div>
                            <div className={`qa multiline multiple-qa${this.isQuestionUnanswered(question.id, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                                {question.value.questions.map((q, index) => {
                                    return (
                                        <div key={`${question.id}-${index}`} class="ml">
                                            <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + index}>{q.value.label}</label>
                                            <input className="answer textarea" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + index} onChange={(e) => this.selectAnswer(canBeCopied, question.id + "-" + index, dispCond, subgroup, groupTitle, e)} value={this.singleLineValue(question.id + "-" + index)}></input>
                                        </div>)
                                })}
                            </div>
                        </>)
                    } else {
                        toReturn.push(
                            <div className={`qa multiline${this.isQuestionUnanswered(question.id, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                                <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id}>{firstQuestionAccessor.label}</label>
                                <textarea className="answer textarea" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id} onChange={(e) => this.selectAnswer(canBeCopied, question.id, dispCond, subgroup, groupTitle, e)} value={this.singleLineValue(question.id)}></textarea>
                            </div>
                        )
                    }
                } else if (type === "radio") {

                    toReturn.push(
                        <div className={`${question.value.extra_classes} qa radio${this.isQuestionUnanswered(question.id, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                            <div className="question" >{question.value.title}{firstQuestionAccessor.tooltip && <>&nbsp;<Tooltip text={firstQuestionAccessor.tooltip} /></>}</div>
                            <div className="answer radio">
                                {this.renderRadioQ(canBeCopied, questions, question.id, dispCond, subgroup, groupTitle)}
                            </div>
                            {this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && conditions.length > 0 &&
                                <div className="conditionals">
                                    {this.renderConditionalQuestion(canBeCopied, conditions, question, subgroup, groupTitle, questions, "radio", dispCond)}
                                </div>
                            }
                        </div>
                    )
                } else if (type === "checkbox" || type === "checkboxes") {
                    toReturn.push(
                        <div className={`${question.value.extra_classes} qa radio${this.isQuestionUnanswered(question.id, this.props.customerId, this.props.offerType, groupTitle, subgroup) ? ' error' : ''}`}>
                            <div className="question" >{question.value.title}</div>
                            <div className="answer radio">
                                {this.renderCheckboxQ(questions, question.id, dispCond, subgroup, groupTitle, type, canBeCopied)}
                            </div>
                            {this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && conditions.length > 0 &&
                                <div className="conditionals">
                                    {this.renderConditionalQuestion(canBeCopied, conditions, question, subgroup, groupTitle, questions, "checkbox", dispCond)}
                                </div>
                            }
                        </div>
                    )
                } else if (type === "lookup_dropdown") {
                    toReturn.push(this.renderLookupDropdown(questions, question.id, subgroup, groupTitle))
                } else if (type === "multi_answer_box") {
                    let conditionalQuestion = false;
                    toReturn = toReturn.concat([this.renderMultiQuestionAnswers(question, subgroup, groupTitle, conditionalQuestion), this.renderMultiAnsQuestionBtn(question, subgroup, groupTitle, canBeCopied, dispCond)])
                }
            } else if (question.type === "lookup_block") {
                toReturn.push(<SsnLookup conditionalLookup={false} question={question} customerId={this.props.customerId} offerType={this.props.offerType} dispCond={dispCond} selectAnswer={this.selectAnswer} subgroup={subgroup} groupTitle={groupTitle} />)
            } else if (question.type === "text_block") {
                toReturn.push(<div className={`${question.value.extra_classes} qa text-block`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(question.value.text_block.replace(/(?:\r\n|\r|\n)/g, '<br>')) }}></div>)
            }
            if (identifier === "paymentAlert") {
                let idForCalc = this.props.customerId
                if (this.props.offerType === "REN" || this.props.offerType === "FOR") {
                    idForCalc = this.props.infoCollection["RENinsuranceTaker"]
                }
                if (this.props.offerType === "RIS") {
                    idForCalc = this.props.infoCollection["RISinsuranceTaker"]
                }
                let totalValue = calculateTotalMonthlyPayment(this.props.offers, this.props.totalInfoCollection, idForCalc)
                if (this.props.offers && this.props.infoCollection && this.props.customerId && parseFloat(this.singleLineValue(question.id)) < parseFloat(totalValue)) {
                    toReturn.push(
                        <Alert variant="warning">
                            Greiðslugeta er lægri en samanlögð iðgjöld umsóknar (€{formatMoney(totalValue, 2)})
                        </Alert>
                    )
                }
            }

            if (identifier === "sustainabilityAlert") {
                let show = false;
                let customerId = this.props.customerId;
                let offerType = this.props.offerType;
                $.each($("#accordion-" + customerId + "-" + offerType + " .one_should_be_checked_parent input:checked"), function (index, value) {
                    let parent = $(value).parents('.one_should_be_checked_parent')[0];
                    let childrenId = parent.className.match(/childrenid_(\S+)/)[1]
                    let children = $(`#accordion-${customerId}-${offerType} .one_should_be_checked_${childrenId} input:checked`)
                    if (children.length > 0) {
                        show = true;
                    }
                });
                if (show) {
                    let showStopper = false;
                    if(this.state.sustainabilitycheck && this.state.sustainabilitycheck[this.props.customerId]){
                        let answers = this.state.sustainabilitycheck[this.props.customerId]
                        showStopper = Object.values(answers).some((s) => s === true)
                    }
                    toReturn.push(<div id="sustainabilityAlert" className={`alert alert-${showStopper ? 'danger' : 'success'}`}>
                        {showStopper ?
                            <p>Einstaklingsbundið val þitt á sjálfbærnikostum samræmist ekki sjálfbærnieiginleikum valdrar tryggingar.</p>
                            :
                            <p>Einstaklingsbundið val þitt á sjálfbærnikostum samsvarar sjálfbærnieiginleikum valdrar tryggingar.</p>
                        }
                    </div>
                    )
                }
            }

            const questionKeyBase = question.id || identifier || 'question'
            return toReturn.map((item, idx) => (
                <React.Fragment key={`${questionKeyBase}-${idx}`}>
                    {item}
                </React.Fragment>
            ))

        }
    }

    renderQuestions(questions, title, canBeCopied) {
        let allQuestions = questions.map((question) => {
            return (this.getSingleQuestion(question, title, canBeCopied))
        })
        return allQuestions;
    }

    sortAdditionalQuestions(additionalQuestions) {
        if (additionalQuestions) {
            let converted = Object.keys(additionalQuestions).map(key => {return {"key": key, "label": additionalQuestions[key]}});
            return converted.sort((a,b ) => a.label.localeCompare(b.label));
        } else {
            return null;
        }
    }

    render() {
        let healthQuestions = this.props.healthQuestions;
        let infoCollection = this.props.infoCollection;

        return (
            <>  {!healthQuestions.isFetching && healthQuestions &&
                <div className="row">
                    <div className="p-0 col-12" id={"accordion-" + this.props.customerId + "-" + this.props.offerType}>
                        {Object.entries(healthQuestions.results).map(([key, value]) => {
                            if (key === this.props.offerType && value && value.length > 0) {
                                let addtionalQuestionsList = value.addtionalQuestionsList && Object.keys(value.addtionalQuestionsList).length > 0 ? 
                                    this.sortAdditionalQuestions(value.addtionalQuestionsList[this.props.offerType]) : null;
                                return (
                                    <React.Fragment key={`offer-${key}`}>
                                        {isMainQuestiongroupConfirmed(value, infoCollection, healthQuestions, this.props.customerId, this.props.offerType, this.props.offers) ? (
                                            this.props.showStopper
                                            ?
                                            <span className="check">
                                                <span className="check-icon big red" style={{color:"white", textAlign: "center", fontWeight:"bold", fontSize: "26px", paddingTop: "4px" }}>
                                                !
                                                </span>
                                            </span>
                                            :
                                            <span className="check">
                                                <span className="check check-icon big green">
                                                <SvgCheckIcon />
                                                </span>
                                            </span>) : (<span></span>)}
                                        <p className="content-title group-heading collapsed" data-toggle="collapse" href={"#" + this.props.offerType + "-" + this.props.customerId} role="button" aria-expanded="false" aria-controls={this.props.offerType + "-" + this.props.customerId}>
                                            {this.props.title }
                                            <span className="arrow-toggle-button">
                                                <SvgArrowIcon />
                                            </span>
                                        </p>
                                        {value.map((question_package, packageIdx) =>
                                            <React.Fragment key={`package-${key}-${packageIdx}`}>
                                                {question_package.value.question_groups.map((questionGroup, idx) => {
                                                    if (questionGroup.display_on_condition == true && questionGroup.display_condition == 'death_benefits=true' && this.props.infoCollection.RENdeathbenefits === false || questionGroup.questions.length === 0) {
                                                        return null
                                                    } else {
                                                        return (<div key={idx} className="collapse" id={this.props.offerType + "-" + this.props.customerId}>
                                                            <div className="accordion">
                                                                <div className="card">
                                                                    <div className="group-type collapsed card-header" data-toggle="collapse" data-target={"#collapse-" + this.props.customerId + '-' + question_package.value.title.replace(/\s/g, '') + '-' + key + '-' + idx} aria-expanded="false" aria-controls={"#collapse-" + idx}>
                                                                        <button className="toggle-button">
                                                                            {(areHealthQuestionsConfirmed(questionGroup, infoCollection, healthQuestions, this.props.customerId, this.props.offerType, this.props.offers) && isAnySinglePaymentCheckboxChecked(questionGroup, infoCollection, healthQuestions, this.props.customerId, this.props.offerType)) ? (
                                                                            questionGroup.containsShowStopper
                                                                            ?
                                                                            <span className="check">
                                                                                <span className="check-icon big red" style={{color:"white", textAlign: "center", fontWeight:"bold" }}>
                                                                                !
                                                                                </span>
                                                                            </span>
                                                                            :
                                                                            <span className="check">
                                                                                <span className="check check-icon big green">
                                                                                <SvgCheckIcon />
                                                                                </span>
                                                                            </span>) : (<span></span>)}
                                                                            {questionGroup.title}
                                                                            <span className="arrow-toggle-button">
                                                                                <SvgArrowIcon />
                                                                            </span>
                                                                        </button>
                                                                    </div>
                                                                    <div id={"collapse-" + this.props.customerId + '-' + question_package.value.title.replace(/\s/g, '') + '-' + key + '-' + idx} className="collapse group-questions" aria-labelledby="headingOne" data-parent={"#accordion-" + this.props.customerId + "-" + this.props.offerType} name={questionGroup.title}>
                                                                        {this.renderQuestions(questionGroup.questions, questionGroup.title, questionGroup.can_be_copied_between_insurance_takers)}
                                                                    </div>
                                                                </div>
                                                            </div>{
                                                            // add addtionalquestion selector 
                                                            idx == 1 && addtionalQuestionsList?
                                                            <div className="accordion">
                                                                <div className="card">
                                                                    <div className="group-type collapsed card-header" data-toggle="collapse" data-target={"#collapse-" + this.props.customerId + '-additional-questions-selector' + '-' + key + '-' + idx} aria-expanded="false" aria-controls={"#collapse-" + idx}>
                                                                        <button className="toggle-button">
                                                                            {(this.state.additionalQuestionsSet) ? (
                                                                                <span className="check"><span className="check check-icon big green">
                                                                                <SvgCheckIcon />
                                                                            </span></span>) : (<span></span>)}
                                                                            Bæta við aukaspurningum
                                                                            <span className="arrow-toggle-button">
                                                                                <SvgArrowIcon />
                                                                            </span>
                                                                        </button>                                                                    
                                                                    </div>
                                                                    <div id={"collapse-" + this.props.customerId + '-additional-questions-selector' + '-' + key + '-' + idx} className="collapse group-questions addtional-questions-list" aria-labelledby="headingOne" data-parent={"#accordion-" + this.props.customerId + "-" + this.props.offerType} name={questionGroup.title}>
                                                                        <br/>                                                                        
                                                                        {addtionalQuestionsList.map(itm => {  
                                                                            return (<div key={key+itm.key} className="form-row align-items-center checkbox">
                                                                            <input type="checkbox" id={"additional-q-"+this.props.customerId+"-"+key+"-"+itm.key} name={"additional-q-"+this.props.customerId+"-"+key+"-"+itm.key} onChange={(e) => this.onCheckboxChange(e, this.props.customerId+'-'+key+'-'+itm.key)} />
                                                                            <span className="checkmark"></span>
                                                                            <label htmlFor={"additional-q-"+this.props.customerId+"-"+key+"-"+itm.key} className="col-form-label col-10 col-sm-8">{itm.label}</label>
															                </div>)})}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            :<></>
                                                            }</div>)
                                                    }
                                                })}
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                )
                            }
                            return null
                        })}
                    </div>
                    {(this.props.showStopper && this.props.offerType === "RIS") &&
                        <Alert variant="danger">
                            Ekki er hægt að senda inn umsókn ef umsækjandi hefur sótt um eða fengið bætur vegna umönnunar
                        </Alert>
                    }
                    {(this.props.showStopper && this.props.offerType !== "RIS") &&
                        <Alert variant="danger">
                            <>{(() => {
                                switch (this.props.showStopperType) {
                                    case "origin":
                                        return "Svar umsækjanda gefur til kynna að viðskiptin séu ekki að eigin frumkvæði eða að umsækjandi starfi fyrir hönd annars aðila. Af þeim sökum er ekki hægt að halda áfram með umsóknina."
                                    case "investment":
                                        return "Valin ávöxtunarleið er ekki í takt við valin fjárfestingarmarkmið. Ekki er hægt að halda áfram með umsókn."
                                    default:
                                        return "Ekki er hægt að halda áfram með umsókn. Vinsamlegast hafðu samband við skrifstofu Allianz."

                                }
                            })()
                            }</>
                        </Alert>
                    }
                </div>
            }
            </>
        )
    }
}

HealthQuestions.defaultProps = {
    title: "Viðbótarupplýsingar"
}

export default HealthQuestions;